import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import Text from '../../atoms/Text';

const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 22px;
`;


const CompletedPage = ({ appType, ...props }) => {
  const location = appType === 'kolour_tw' ? '荃灣千色匯' : '元朗千色匯';
  return (
    <Container>
      <Text variant="h2" align="center">尋找NINA及白熊與男孩</Text>
      <Text variant="h2" align="center">換領商場優惠券</Text>
      <Flex mt="1rem" flexDirection="column" alignItems="center">
        <Text variant="h3">恭喜閣下已換領</Text>
        <Text variant="h3" palette="tertiary">{location}HK$50購物及</Text>
        <Text variant="h3" palette="tertiary">HK$50餐飲優惠券各乙張</Text>
        <Text variant="h3">多謝參與！</Text>
      </Flex>
      <Flex mt="1rem">
        <Text variant="body2">(每位H•COINS會員只限換領乙套，以電腦紀錄為準)</Text>
      </Flex>
      <Flex justifyContent="flex-end" width={1} mt="auto">
        <Text fontType="tertiary" variant="body2">*條款及細則適用</Text>
      </Flex>
    </Container>
  );
};

CompletedPage.propTypes = {
  appType: PropTypes.string,
};

CompletedPage.defaultProps = {
  appType: 'kolour_tw',
};

export default CompletedPage;
